/* eslint-disable no-param-reassign */
import { captureMessage } from '@sentry/react';
import { saveToken } from '../../redux/modules/users/actions';
import { store } from '../../redux/store';
import {
  getExternalSessionType,
  isElectron,
  isExternalSession,
  isTokenAboutExpire
} from '../../utils';
import { requestToAccessToken as getConnectwiseToken } from '../connectWiseHostedAPI/utils';
import { requestToAccessToken as getAutotaskToken } from '../autotask';
import { createChatgenieAuth0 } from '../../providers/Auth0Provider';
import { EXTERNAL_SESSION_TYPES } from '../../constants';

const refreshTokenForExternalSession = async () => {
  const sessionType = getExternalSessionType();
  if (sessionType === EXTERNAL_SESSION_TYPES.CONNECTWISE) {
    return getConnectwiseToken();
  }
  if (sessionType === EXTERNAL_SESSION_TYPES.AUTOTASK) {
    return getAutotaskToken();
  }
};

export const refreshAccessToken = async () => {
  try {
    let token = null;
    if (isElectron()) {
      const remote = window.require('@electron/remote');
      const authService = remote.require('./services/auth-service');
      await authService.refreshTokens();
      token = authService.getAccessToken();
    } else if (isExternalSession()) {
      const accessToken = await refreshTokenForExternalSession();
      token = accessToken;
    } else {
      const client = await createChatgenieAuth0();
      token = await client.getTokenSilently();
    }
    store.dispatch(saveToken(token));
    return token;
  } catch (err) {
    const message = err?.response?.data?.message || err?.message || 'Unknown';
    captureMessage(`Refreshing access token failed: ${message}`);
    throw err;
  }
};
export const shouldLogout = response => response?.status === 401;

const appIdRelatedErrorMessages = [
  'Header has not APP_ID',
  "Most likely request doesn't have correct APP ID.",
  'exception.app-id-belong-no-yours-company',
  'Cannot access such company'
];
export const shouldClearSavedAppId = response =>
  response?.status === 403 && appIdRelatedErrorMessages.includes(response?.data?.message);

export const getValidToken = async currentToken => {
  let token = currentToken;
  try {
    if (isTokenAboutExpire(token)) {
      token = await refreshAccessToken();
    }
    return token;
  } catch {
    return token;
  }
};

export const updateHeaders = async (headers = {}) => {
  try {
    const user = store.getState()?.users?.user;
    if (!headers.Authorization) {
      if (user.token) {
        let { token } = user;
        token = await getValidToken(token);
        headers.Authorization = `Bearer ${token}`;
      }
    }
    if (user.appId) {
      headers['APP-ID'] = user.appId;
    }
    return headers;
  } catch {
    return headers;
  }
};
